import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ToastService } from '../toast.service';

@Component({
  selector: 'app-view-transaction-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './view-transaction-modal.component.html',
  styleUrls: ['./view-transaction-modal.component.scss']
})
export class ViewTransactionModalComponent implements OnInit {
  @Input() transaction: any;
  @Output() close = new EventEmitter<void>();

  loading = false;
  fullTransaction: any = null;

  constructor(
    private http: HttpClient,
    private toastService: ToastService
  ) { }

  ngOnInit() {
    this.fetchTransactionDetails();
  }

  fetchTransactionDetails() {
    this.loading = true;
    this.http.get<any>(`${environment.apiBaseUrl}/transaction/${this.transaction.id}`)
      .subscribe({
        next: (res) => {
          if (res.statusCode === 200 && res.data) {
            this.fullTransaction = res.data;
          }
          this.loading = false;
        },
        error: (err) => {
          this.toastService.error(err?.error?.message || 'Failed to fetch transaction details');
          this.loading = false;
        }
      });
  }

  onClose() {
    this.close.emit();
  }

  downloadInvoice() {
    if (!this.fullTransaction?.reference_id) {
      this.toastService.error('Invoice reference not found');
      return;
    }

    this.http.get<any>(`${environment.apiBaseUrl}/invoice/download/${this.fullTransaction.reference_id}`)
      .subscribe({
        next: (res) => {
          if (res.url) {
            window.open(res.url, '_blank');
          } else {
            this.toastService.error('Download URL not found');
          }
        },
        error: (err) => {
          this.toastService.error(err?.error?.message || 'Failed to download invoice');
        }
      });
  }

  getStatusClass(status: string): string {
    switch (status?.toLowerCase()) {
      case 'success': return 'status-success';
      case 'pending': return 'status-pending';
      case 'failed': return 'status-failed';
      default: return '';
    }
  }

  getTypeClass(type: string): string {
    return type === 'credit' ? 'type-credit' : 'type-debit';
  }
}
